<template>
  <div class="apply-form-container">
    <h1>学分认定申请</h1>
    <div class="form-content">
      <div v-if="!successVisable" class="form-middle">
        <a-form
          :form="form"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
          @submit="handleSubmit"
        >
          <a-row>
            <a-col :span="12">
              <a-form-item label="教学点">
                {{ this.userInfo.siteName }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="层次">
                {{ this.userInfo.learnLevel }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="专业">
                {{ this.userInfo.proName }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="学号">
                {{ this.userInfo.studentNo }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="学生姓名">
                {{ this.userInfo.name }}
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item
                label="认证类别"
                :label-col="{ span: 4 }"
                :wrapper-col="{ span: 20 }"
              >
                <a-select
                  v-decorator="['type', validatorRules.type]"
                  @change="onSelectChange"
                >
                  <a-select-option
                    v-for="(item, index) in typeList"
                    :key="index"
                    :value="item.itemValue"
                  >
                    {{ item.itemText }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="isAllowCert == 1">
              <a-form-item
                label="可用证书"
                :label-col="{ span: 4 }"
                :wrapper-col="{ span: 20 }"
              >
                <a-select
                  v-decorator="['certType', validatorRules.certType]"
                  @change="onCertSelectChange"
                >
                  <a-select-option
                    v-for="(item, index) in certList"
                    :key="index"
                    :value="item.itemValue"
                  >
                    {{ item.itemText }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="认证学分">
                <div style="color: red">{{ formData.applyCredit }}</div>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item
                label="标准库内容"
                :label-col="{ span: 4 }"
                :wrapper-col="{ span: 20 }"
              >
                <a-textarea
                  v-model="formData.applyDesc"
                  placeholder="请输入标准库内容"
                  rows="3"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item
                label="申请理由"
                :label-col="{ span: 4 }"
                :wrapper-col="{ span: 20 }"
              >
                <a-textarea
                  v-model="formData.applyReason"
                  placeholder="请输入申请理由"
                  rows="3"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item
                label="上传附件"
                :label-col="{ span: 4 }"
                :wrapper-col="{ span: 20 }"
              >
                <docUpload
                  v-decorator="['file', validatorRules.file]"
                  hideTip
                  required
                  ref="childRef"
                  :info="uploadItemDefault"
                  @change="onFileChange"
                  @remove="onFileRemove"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item :wrapper-col="{ span: 12, offset: 8 }">
            <a-button
              type="primary"
              html-type="submit"
              class="submit-btn"
              :loading="submitLoading"
              >提交申请</a-button
            >
            <a-button class="clear-btn" @click="handleClear">清空内容</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-if="successVisable" class="success-content">
        <img src="../../../assets/images/log-success.png" />
        <div class="success-text">
          申请提交成功！请耐心等待审核，审核通过后，即可兑换课程！
        </div>
        <div class="success-btns">
          <a-button
            type="primary"
            class="submit-btn"
            @click="handleContinueApply"
            >继续申请</a-button
          >
          <a-button class="clear-btn" @click="handleReturnList"
            >返回列表</a-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import docUpload from "./docListUpload";

export default {
  name: "ApplyList",
  components: {
    docUpload,
  },
  data: function () {
    return {
      form: this.$form.createForm(this, { name: "coordinated" }),
      validatorRules: {
        type: {
          rules: [{ required: true, message: "请选择认证类别!" }],
        },
        certType: {
          rules: [{ required: true, message: "请选择证书!" }],
        },
        file: {
          rules: [{ required: true, message: "请上传附件" }],
        },
      },
      submitLoading: false,
      successVisable: false,
      formData: {
        creditsTypeId: "", // 所属认定类别Id
        creditsTypeName: "", // 所属认定类别名称
        creditsCertId: "", // 证书Id
        creditsCertName: "", // 证书名称
        applyCredit: 0, // 申请学分
        applyDesc: "", // 标准库内容
        applyReason: "", // 认定申请理由
      },
      typeList: [],
      certList: [], // 证书列表下拉数据
      delFileIds: [],
      fileList: [],
      isAllowCert: 0, // 是否走证书
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    uploadItemDefault() {
      return {
        typeNotes: "仅支持 .pdf 文件",
        fileTitle: "",
        isInput: 0,
        fileSize: 20,
        fileNumber: 1,
        fileList: [],
        fileType: ".pdf",
      };
    },
  },
  methods: {
    // 获取认定类别下拉数据
    getTypeList() {
      this.axios.get(`/biz/credit/identified/typeQry`).then((res) => {
        if (res.success) {
          const { result } = res;
          this.typeList = result.map((item) => ({
            itemText: item.typeName,
            itemValue: item.id,
            chargeScore: item.chargeScoreStandard,
          }));
        }
      });
    },
    // 获取认证类别下证书信息
    getTypeCert(id) {
      this.axios
        .get(`/biz/credit/identified/certQry?typeId=${id}`)
        .then((res) => {
          if (res.success) {
            const { result } = res;
            this.certList = result.map((item) => ({
              itemText: item.certName,
              itemValue: item.id,
              chargeScore: item.certScore,
            }));
          }
        });
    },
    // 选择认证类别
    onSelectChange(value) {
      const selected = this.typeList.find((item) => item.itemValue === value);
      if (this.isAllowCert == 0) {
        this.formData.applyCredit = selected.chargeScore;
      }
      this.formData.creditsTypeId = value;
      this.formData.creditsTypeName = selected.itemText;
      if (this.isAllowCert == 1) {
        this.getTypeCert(value);
      }
    },
    onCertSelectChange(value) {
      const selected = this.certList.find((item) => item.itemValue === value);
      this.formData.applyCredit = selected.chargeScore;
      this.formData.creditsCertId = value;
      this.formData.creditsCertName = selected.itemText;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (!this.fileList.length) {
            this.$message.error("请上传文件");
            return;
          }
          this.submitLoading = true;
          const fileUrl = this.fileList[0].docUrl;
          const params = {
            ...this.formData,
            fileUrl,
          };
          params.applyCredit = undefined;
          this.axios
            .post(`/biz/credit/identified/apply`, params)
            .then((res) => {
              if (res.success) {
                this.successVisable = true;
              }
            })
            .finally(() => {
              this.submitLoading = false;
            });
        }
      });
    },
    onFileChange({ file, configId }) {
      this.fileList.push({
        uid: file.uid,
        docUrl: file.url,
        id: file.id,
        docName: file.name,
        fileSize: file.size,
        configId,
        remark: file.remark
      });
    },
    onFileRemove({ id, uid }) {
      const index = this.fileList.findIndex((item) => item.uid === uid);
      this.fileList.splice(index, 1);
      if (id) this.delFileIds.push(id);
    },
    handleClear() {
      this.form.resetFields();
      this.formData = {};
      this.delFileIds = [];
      this.fileList = [];
      this.$refs.childRef.clearFiles();
    },
    handleContinueApply() {
      this.successVisable = false;
      this.handleClear();
    },
    handleReturnList() {
      this.$router.push("/creditBank");
    },
  },
  created() {
    this.getTypeList();
  },
  mounted() {
    this.formData.creditsTypeId = this.$route.query.id;
    this.formData.creditsTypeName = this.$route.query.creditsTypeName;
    this.formData.creditsCertId = this.$route.query.creditsCertId;
    this.formData.creditsCertName = this.$route.query.creditsCertName;
    this.formData.applyDesc = this.$route.query.applyDesc;
    this.formData.applyReason = this.$route.query.applyReason;
    this.formData.applyCredit = this.$route.query.applyCredit;
    this.isAllowCert = this.$route.query.isAllowCert;
    if (this.$route.query.isAllowCert && this.$route.query.creditsCertId) {
      this.getTypeCert(this.$route.query.id);
    }
    this.$nextTick(() => {
      this.form.setFieldsValue({
        type: this.$route.query.id,
        certType: this.$route.query.creditsCertId,
      });
    });
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.apply-form-container {
  min-height: calc(100vh - 584px);
   h1 {
     font-size: 16px;
     color: $color-text-base;
     font-weight: bold;
     margin-bottom: 24px;
   }
  .form-content {
    width: 100%;
    background: #fff;
    padding: 28px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .form-middle {
      width:600px;
    }
    .success-content {
      height: 300px;
      margin-top: 80px;
      text-align: center;
      .success-text {
        color: #333333;
        font-size: 18px;
        margin-top: 24px;
    }
    .success-btns {
      margin-top: 24px;
    }
    }
    .form-middle >>> .ant-form-item {
      margin-bottom: 0px;
    }
  }
  .submit-btn {
    width: 120px;
    height: 36px;
    line-height: 36px;
    padding: 0;
    background: #2caf7a;
    text-align: center;
    color: #fff;
    border: none;
    border-radius: 4px;
    margin-right: 30px;
}
  .clear-btn {
    width: 120px;
    height: 36px;
    line-height: 36px;
    padding: 0;
    text-align: center;
    border-radius: 4px;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/creditBank/components/ApplyForm.vue